var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUsd = function SvgUsd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M9,2 L9,0 L10,0 L10,2.00947241 C11.6781119,2.13712863 13,3.53919256 13,5.25 L12,5.25 C12,4.09186159 11.1249876,3.13809327 10,3.01373219 L10,7.50947241 C11.6781119,7.63712863 13,9.03919256 13,10.75 C13,12.4608074 11.6781119,13.8628714 10,13.9905276 L10,16 L9,16 L9,14 L7,14 L7,16 L6,16 L6,13.9905276 C4.32188807,13.8628714 3,12.4608074 3,10.75 L4,10.75 C4,11.9081384 4.87501239,12.8619067 6,12.9862678 L6,8.49052759 C4.32188807,8.36287137 3,6.96080744 3,5.25 C3,3.53919256 4.32188807,2.13712863 6,2.00947241 L6,0 L7,0 L7,2 L9,2 Z M9,3 L7,3 L7,7.5 L8,7.5 L9,7.5 L9,3 Z M9,13 L9,8.5 L7,8.5 L7,13 L9,13 Z M10,12.9862678 C11.1249876,12.8619067 12,11.9081384 12,10.75 C12,9.59186159 11.1249876,8.63809327 10,8.51373219 L10,12.9862678 Z M6,3.01373219 C4.87501239,3.13809327 4,4.09186159 4,5.25 C4,6.40813841 4.87501239,7.36190673 6,7.48626781 L6,3.01373219 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/USD.b3959e2d.svg";
export { ForwardRef as ReactComponent };